import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=217bea72"
import script from "./CompanyNews.vue?vue&type=script&lang=js"
export * from "./CompanyNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports